import { FC, useEffect, useRef } from 'react'
import cn from 'clsx'
import s from './NavOverlay.module.scss'
import { Container } from '@components/ui'
import { useUI } from '@components/ui/context'
import { useGlobalContentContext } from '@context/GlobalContentContext'
import { clearAllBodyScrollLocks, disableBodyScroll } from 'body-scroll-lock'
import NavBlocks from './NavBlocks'

const NavOverlay: FC = () => {
  const { pageTheme, displayLoreThreeNavOverlay, setPageTheme } = useUI()

  const ref = useRef<HTMLDivElement>(null)

  const { data } = useGlobalContentContext()

  useEffect(() => {
    const overlay = ref.current
    if (!overlay) return

    if (displayLoreThreeNavOverlay) {
      disableBodyScroll(overlay, { reserveScrollBarGap: true })
    }

    !displayLoreThreeNavOverlay && clearAllBodyScrollLocks()

    return () => {
      clearAllBodyScrollLocks()
    }
  }, [displayLoreThreeNavOverlay])

  if (!data.lorethreeNav) return null

  return (
    <div
      className={cn(s.container, {
        [s.darkMode]: pageTheme == 'LIGHT',
        [s.active]: displayLoreThreeNavOverlay,
      })}
    >
      <div className={s.scrollContainer} ref={ref}>
        <NavBlocks />
      </div>
    </div>
  )
}

export default NavOverlay
